import React from 'react'
import PropTypes from 'prop-types'


// Styles
import { white, grey } from 'hfty-styles/src/colors'

const searchInputStyle = {
  border: 0,
  backgroundColor: white(),
  color: grey(),
  flex: '1 1 auto',
  padding: '10px 7px',
}

// Local
export default function SearchInput ({value, placeholder, onInput}) {
  return (
    <input
      value={value}
      placeholder={placeholder}
      onInput={onInput}
      style={searchInputStyle}
    />
  )
}

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onInput: PropTypes.func.isRequired,
}
